import Swiper, { Autoplay, Pagination, Navigation } from 'swiper'

Swiper.use([Autoplay, Pagination, Navigation])

export const ProductImagesSlider = {
  init: () => {
    ProductImagesSlider.initializeSwiper()
  },

  initializeSwiper: () => {
    const root = document.querySelector<HTMLDivElement>('.product-images-slider')
    const swiper = document.querySelector<HTMLButtonElement>('.product-images-slider__swiper')
    const pagination = document.querySelector<HTMLDivElement>('.product-images-slider__pagination')
    if (!root || !swiper || !pagination) return

    // @ts-ignore
    new Swiper(swiper, {
      direction: 'horizontal',
      wrapperClass: 'product-images-slider__wrapper',
      slideClass: 'product-images-slider__slide',
      loop: true,
      grabCursor: true,
      autoHeight: false,
      slidesPerView: 1,
      pagination: {
        el: '.product-images-slider__pagination',
        bulletClass: 'product-images-slider__bullet',
        bulletActiveClass: 'product-images-slider__bullet--active',
        clickable: true,
        renderBullet: (_, className) => {
          return `<button type="button" class="${className}"></button>`
        }
      },
      navigation: {
        nextEl: '.product-images-slider__button--next',
        prevEl: '.product-images-slider__button--prev',
      },
      speed: 600,
    })

  },
}